import React from 'react';
import { Box } from '@mui/material';

const SplitText = ({ text, chunk }) => {
  const splitText = (text) => {
    if (!text) return []; // Handle null or undefined text

    const lines = [];
    let currentLine = "";

    for (let i = 0; i < text.length; i++) {
      currentLine += text[i];

      if (currentLine.length >= chunk || i === text.length - 1) {
        lines.push(currentLine);
        currentLine = ""; // Start a new line
      }
    }

    return lines;
  };

  const lines = splitText(text);

  return (
    <div>
      {lines.map((line, index) => (
        <div key={index}>
            {line}
        </div>// Or use a <span> if you don't want paragraphs
      ))}
    </div>
  );
};

export default SplitText;